const pageNameKey = "nodeManagerNavigationButtons";

export const nodeManagerNavigationButtonsEn = {
  [pageNameKey]: {
    goToDashboard: "Go to Dashboard",
    goToTreeStructure: "Go to Tree Structure",
    goToConditionMonitoring: "Go to Condition Monitoring",
    goToMachineSettings: "Go to Machine Settings",
    requestRemoteTechnicalSupport: "Request remote technical support",
    goToShotDataTable: "Go to Shot Data Table",
  },
};

export const nodeManagerNavigationButtonsPtBr = {
  [pageNameKey]: {
    goToDashboard: "Ir para o painel",
    goToTreeStructure: "Ir para Estrutura de Árvore",
    goToConditionMonitoring: "Acesse o Monitoramento de condição",
    goToMachineSettings: "Vá para as Configurações da máquina",
    requestRemoteTechnicalSupport: "Solicitar suporte técnico remoto",
    goToShotDataTable: "Ir para a Tabela de dados shot",
  },
};

export const nodeManagerNavigationButtonsDe = {
  [pageNameKey]: {
    goToDashboard: "Zum Dashboard gehen",
    goToTreeStructure: "Zur Baumstruktur gehen",
    goToConditionMonitoring: "Zur Zustandsüberwachung gehen",
    goToMachineSettings: "Gehen Sie zu Maschineneinstellungen",
    requestRemoteTechnicalSupport: "Remote-Technische Unterstützung anfordern",
    goToShotDataTable: "Zur Shot-Datentabelle gehen",
  },
};

export const nodeManagerNavigationButtonsZhHans = {
  [pageNameKey]: {
    goToDashboard: "转到仪表板",
    goToTreeStructure: "转到树结构",
    goToConditionMonitoring: "转到状态监控",
    goToMachineSettings: "转到机器设置",
    requestRemoteTechnicalSupport: "请求远程技术支持",
    goToShotDataTable: "转到注射数据表",
  },
};

export const nodeManagerNavigationButtonsIt = {
  [pageNameKey]: {
    goToDashboard: "Vai alla dashboard",
    goToTreeStructure: "Vai alla struttura nodi",
    goToConditionMonitoring: "Vai al monitoraggio condizioni",
    goToMachineSettings: "Vai alle impostazioni macchina",
    requestRemoteTechnicalSupport: "Richiedi supporto tecnico remoto",
    goToShotDataTable: "Vai alla tabella dati shot",
  },
};

export const nodeManagerNavigationButtonsEs = {
  [pageNameKey]: {
    goToDashboard: "Ir a la dashboard",
    goToTreeStructure: "Ir a estructura en árbol",
    goToConditionMonitoring: "Ir a monitorización de condición",
    goToMachineSettings: "Ir a la configuración de la máquina",
    requestRemoteTechnicalSupport: "Solicitar asistencia técnica remota",
    goToShotDataTable: "Ir a la tabla de datos shot",
  },
};

export const nodeManagerNavigationButtonsNl = {
  [pageNameKey]: {
    goToConditionMonitoring: "Ga naar conditiebewaking",
    goToDashboard: "Ga naar dashboard",
    goToMachineSettings: "Ga naar machine-instellingen",
    goToTreeStructure: "Ga naar boomstructuur",
    requestRemoteTechnicalSupport: "Externe technische ondersteuning aanvragen",
    goToShotDataTable: "Ga naar Shot-Datentabel",
  },
};

export const nodeManagerNavigationButtonsTr = {
  [pageNameKey]: {
    goToConditionMonitoring: "Durum İzlemeye Git",
    goToDashboard: "Kontrol Paneline Git",
    goToMachineSettings: "Makine Ayarlarına Git",
    goToTreeStructure: "Ağaç Yapısına Git",
    requestRemoteTechnicalSupport: "Uzaktan teknik destek isteyin",
    goToShotDataTable: "Atış Veri Tablosuna Git",
  },
};
